import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useSession, type UserRole } from "../lib/auth";

interface RequireRoleProps {
  children: ReactNode;
  /** İzinli roller. Verilmezse rol kısıtı yoktur. */
  roles?: readonly UserRole[];
  /** Ürün maliyeti / kâr / kârlılık raporu — yalnızca boss. */
  financeView?: boolean;
  /** Bileşen alış fiyatı / satın alma — boss + office. */
  costView?: boolean;
  /** Yetkisizken gösterilecek özel içerik (varsayılan: 403 paneli). */
  fallback?: ReactNode;
}

/**
 * Ekran seviyesinde yetki kapısı (06-guvenlik/04-yetki-matrisi.md §6).
 *
 * İKİ TASARIM KARARI:
 * 1. Yetkisiz kullanıcı LOGIN'E ATILMAZ. Eski panelde `orders.php` üretim
 *    rolünü `index.php`'ye yönlendiriyordu; kullanıcı oturumunun düştüğünü
 *    sanıyordu. Artık "yetkiniz yok" açıkça yazılır.
 * 2. Bu bileşen yalnızca KULLANILABİLİRLİK katmanıdır. Gerçek koruma her zaman
 *    Firestore Rules + Cloud Function guard'larındadır; menüyü gizlemek
 *    güvenlik önlemi değildir.
 */
export function RequireRole({
  children,
  roles,
  financeView,
  costView,
  fallback,
}: RequireRoleProps) {
  const session = useSession();

  const roleOk = !roles || (session ? roles.includes(session.role) : false);
  const financeOk = !financeView || session?.financeView === true;
  const costOk = !costView || session?.costView === true;

  if (roleOk && financeOk && costOk) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;

  return (
    <div className="mx-auto max-w-xl">
      <div className="rounded-lg border border-amber-300 bg-amber-50 p-5" role="alert">
        <h1 className="text-base font-semibold text-amber-900">Bu ekrana erişim yetkiniz yok</h1>
        <p className="mt-2 text-sm text-amber-900">
          Bu sayfa yalnızca belirli roller içindir. Yetkinizin değişmesi gerekiyorsa
          iş sahibine başvurun.
        </p>
        <p className="mt-3 text-sm text-amber-900">
          <Link to="/" className="link">
            Panele dön
          </Link>
        </p>
      </div>
    </div>
  );
}

export default RequireRole;
